module.exports = __webpack_public_path__ + "img/default_teacher.d961d73a.png";